export const VERSION = process.env.REACT_APP_VERSION
export const API_URL = process.env.REACT_APP_API_URL
export const RECTA_APPKEY = process.env.REACT_APP_RECTA_APPKEY
export const TUTS_URL = process.env.REACT_APP_TUTS_URL
